export const POLICY_FORTIFICATIONISM_FORTRESS_ROUND_END_REPAIRMENT = 1;

export const POLICY_FORTIFICATIONISM_MELEE_BONUS = 3;

export const POLICY_FORTIFICATIONISM_BUILDING_DISCOUNT_FORTRESS = 4;


